import { match, P } from 'ts-pattern';
import { Routes } from 'types';
import type { ApplicationStatus, ApplicationStatusReason } from 'hooks/useGetApplication';

/**
 * Resolve the route for the assisted-apply flow based on application status and reason.
 * Mirrors the logic from merchant-assisted-apply/src/utils/statusRouting.ts.
 */
export function resolveAssistedApplyRoute(
  status: ApplicationStatus,
  statusReason?: ApplicationStatusReason,
): Routes {
  return match({ status, statusReason })
    // Pending customer acceptance
    .with({ status: 'PENDING_CUSTOMER_ACCEPTANCE' }, () => Routes.pendingCustomerAcceptance)

    // Proof of income required
    .with({ status: P.union('POI_CHECK_REQUIRED', 'POI_BIO_CHECK_REQUIRED') }, () => Routes.main)

    // Conditionally approved with POI reasons → proof of income
    .with(
      {
        status: 'CONDITIONALLY_APPROVED',
        statusReason: P.union(
          'PROOF_OF_INCOME',
          'ANTI_MONEY_LAUNDERING_AND_PROOF_OF_INCOME',
          'PROOF_OF_ADDRESS_AND_PROOF_OF_INCOME',
        ),
      },
      () => Routes.main,
    )

    // Everything else → referred
    .otherwise(() => Routes.assistedApplyReferred);
}
